import { Box, IconButton, Grid, Tooltip } from '@mui/material';
import MaterialTable from 'material-table';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import Popup from "../../../../Base/views/Popup"
import { useState } from 'react';
// import ConfirmationDialog from '../../../../Base/views/ConfirmationDialog';
import { 
    // DeleteLeaveWageAction, 
    GetLeaveWageAction } from '../../../../../../store/Finance/PayRollTemplate/Action';
import LeaveWage from './LeaveWage';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const LeaveWageGrid = () => {
    const dispatch = useDispatch();
    const { leave_wage_data, isLoadingLeaveWage } = useSelector(state => state.FinanceReducer?.PayrollTemplateReducer);
    const [editedRecord, setEditedRecord] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    // const [openDialog, setOpenDialog] = useState(false);
    // const [currentData, setCurrentData] = useState({});
  useEffect(() => {
            dispatch(GetLeaveWageAction());
          // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])
    const handleEdit = (rowData) => {
        setEditedRecord(rowData);
        setOpenPopup(true);
    };

    // const handleAdd = () => {
    //     setEditedRecord()
    //     setOpenPopup(true);
    // };
    
    // const handleConfirmDelete = (rowData) => {
    //     setOpenDialog(true);
    //     setCurrentData(rowData)
    // };

    // const handleDelete = () => {
    //     setOpenDialog(false);
    //     dispatch(DeleteLeaveWageAction({ leave_wages_configuration_id: currentData?.leave_wages_configuration_id }))
    // };

    const addMode = (resetForm) => {
        resetForm();
        setEditedRecord(null);
        setOpenPopup(false);
    };

    // const addButton = leave_wage_data?.length < 1 && (<Button onClick={handleAdd} variant="contained" className="mpl-primary-btn" startIcon={<AddIcon />} >
    //     Add
    // </Button>);
    return (
        <Grid container spacing={2} style={{ padding: "10px 0px" }}>
            <Grid item xs={12} md={12}>
                <Box>
                    <MaterialTable
                        isLoading= {isLoadingLeaveWage}
                        columns={[
                            { title: "Earning Components", field: "calculation_earning_components", cellStyle: { padding: "10px 10px 10px 13px" },
                                 render: rowData => {
                                    try {
                                        const arr = typeof rowData?.calculation_earning_components === "string"
                                            ? JSON.parse(rowData.calculation_earning_components)
                                            : rowData.calculation_earning_components;
                                        return Array.isArray(arr)
                                            ? arr?.map(item => item.label).join(", ")
                                            : "";
                                    } catch {
                                        return "";
                                    }
                                }
                            },
                            {  title: (
                                    <span>
                                        Standard Paid Days&nbsp;
                                        <Tooltip title="Fixed number of days (e.g. 26) used to calculate daily wages. Remains constant each month for consistent payroll." placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ), 
                                field: "standard_paid_days", cellStyle: { padding: "10px 10px 10px 13px" } },
                            {  title: (
                                    <span>
                                        Statutory Leave Eligibility Days&nbsp;
                                        <Tooltip title="Number of days (e.g. 20) an employee must work to earn one leave day, as per labor laws." placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ), 
                                field: "leave_eligibility_days", cellStyle: { padding: "10px 10px 10px 13px" } },
                        ]}
                        data={leave_wage_data}
                        options={{
                            maxBodyHeight: 220,
                            rowStyle: { fontSize: "13px" },
                            headerStyle: { padding: "5px 30px 5px 10px", fontWeight: "bold" },
                            sorting: false,
                            search: false,
                            searchFieldAlignment: "right",
                            searchAutoFocus: true,
                            searchFieldVariant: "standard",
                            filtering: false,
                            paging: false,
                            selection: false,
                            actionsColumnIndex: -1,
                            grouping: false,
                            addRowPosition: "first",
                        }}
                        onSelectionChange={(rows) => { return (rows.filter(row => row?.status === "Submitted")) }}
                        actions={[
                            {
                                icon: () => <IconButton sx={{ padding: "0px" }}><EditIcon /></IconButton>,
                                tooltip: "Edit",
                                onClick: (_event, rowData) => { handleEdit(rowData) },
                            },
                            // {
                            //     icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
                            //     tooltip: "Delete",
                            //     onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
                            // },
                        ]}
                        title=""
                        components={{
                            Toolbar: props => (
                                <div style={{
                                    minHeight: "10px",
                                    padding: "10px 25px",
                                    borderRadius:"5px 5px 0px 0px"
                                }}>
                                    {props.title}
                                </div>
                            )
                        }}
                    />
                    <Popup
                        fullWidth={true}
                        maxWidth="sm"
                        title={editedRecord ? "Edit" : "Add"}
                        openPopup={openPopup}
                        setOpenPopup={setOpenPopup}

                    >
                        <LeaveWage editedRecord={editedRecord} addMode={addMode} setOpenPopup={setOpenPopup} />
                    </Popup>
                    {/* <ConfirmationDialog
                        title="Do you wish to proceed?"
                        openDialog={openDialog}
                        closeDialog={setOpenDialog}
                        popupTitle=""
                        OkButtonText="Delete"
                        onSubmit={handleDelete}
                    /> */}
                </Box>
            </Grid>
        </Grid>
    );
}

export default LeaveWageGrid;
